// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__3AghK","priority":"Image_priority__cCg80"};